import { render } from "./Idea-Vision.vue?vue&type=template&id=b69b2cdc&scoped=true"
import script from "./Idea-Vision.vue?vue&type=script&lang=ts"
export * from "./Idea-Vision.vue?vue&type=script&lang=ts"

import "./Idea-Vision.vue?vue&type=style&index=0&id=b69b2cdc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b69b2cdc"

export default script